/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const emailListData = (data, isRefresh) => ({
  type: actiontypes.EMAIL_LIST,
  getEmailList: data,
  isRefreshData: isRefresh,
});
export const getEmailListCheckCall = (data) => ({
  type: actiontypes.EMAIL_LIST_CHECK,
  getEmailListCheck: data,
});
export const emailLogDetailData = (data) => ({
  type: actiontypes.EMAIL_LOG_DETAIL,
  getEmailLogDetail: data,
});
export const emailLogRightGrid = (data) => ({
  type: actiontypes.EMAIL_LOG_RIGHT_GRID,
  getEmailLogRightGrid: data,
});
export const saveEmailogData = (data) => ({
  type: actiontypes.SAVE_EMAIL_LOG,
  saveEmailLog: data,
});
export const errorLeftRightGrid = (data) => ({
  type: actiontypes.ERROR_LEFT_RIGHT_GRID,
  errorLeftRightTbl: data,
});
export const dispatchEmailTypeAvailableList = (data) => ({
  type: actiontypes.EMAIL_AVAILABLE_LIST,
  emailTypeAvailableList: data,
});
export const dispatchSaveList = (data) => ({
  type: actiontypes.SAVE_PAYLOAD_LIST,
  savePayloadList: data,
});
export const dispatchDeleteList = (data) => ({
  type: actiontypes.DELETE_PAYLOAD_LIST,
  deletePayloadList: data,
});
export const getEmailList = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_EMAIL_LIST}`, val)
    .then((response) => {
      let emailListArr = [];
      let emailList = response?.data?.emailAddr.forEach((itemKey) => {
        let listEmailObj = {
          email: itemKey,
          emailNew: false,
        };
        emailListArr.push(listEmailObj);
      });
      dispatch(emailListData(emailListArr, val));
    })
    .catch(() => {
      dispatch(emailListData([]));
    });
};
export const getEmailLogDetail = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_EMAIL_LOG_DETAIL}`, val)
    .then((response) => {
      dispatch(emailLogDetailData(response?.data?.loadEmailResponse));
    })
    .catch(() => {
      dispatch(emailLogDetailData([]));
    });
};
export const saveLogEmail = (val, saveType) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SAVE_LOG_EMAIL}`, val)
    .then((response) => {
      if (saveType) {
        dispatch(saveEmailogData('closeTab'));
      } else {
        dispatch(saveEmailogData(response?.data?.loadEmailResponse));
      }
    })
    .catch(() => {
      dispatch(saveEmailogData([]));
    });
};
export const getEmailTypeAvailableList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.NDC_REFERENCE_DATA, value)
    .then((response) => {
      if (response?.data != '') {
        return dispatch(
          dispatchEmailTypeAvailableList(response?.data?.EMAIL_TYPE_CD)
        );
      } else {
        dispatch(dispatchEmailTypeAvailableList([]));
      }
    })
    .catch(() => {
      dispatch(dispatchEmailTypeAvailableList([]));
    });
};
